import { endOfDay } from "date-fns";
import { useMemo } from "react";

import type { CompleteDateRange } from "@/components/StructuredSearch/stores/structured-search/structured-search-store";

export interface WorkflowVersionTracesDateRangeConfig {
  initialDateRange: CompleteDateRange;
}

interface UseWorkflowVersionTracesDateRangeConfigInput {
  workflowVersion?: {
    created_at: string;
  };
}

/** Initial traces range starts at the version's creation time. */
export const useWorkflowVersionTracesDateRangeConfig = ({
  workflowVersion,
}: UseWorkflowVersionTracesDateRangeConfigInput):
  | WorkflowVersionTracesDateRangeConfig
  | undefined =>
  useMemo(() => {
    if (!workflowVersion) {
      return undefined;
    }

    return {
      initialDateRange: {
        from: new Date(workflowVersion.created_at),
        to: endOfDay(new Date()),
      },
    };
  }, [workflowVersion]);
